import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../helpers/request';

const errorMessage = 'При обновлении комментария произошла ошибка';

const mutationFn = ({ comment, addressId, commentId }) => {
  return request.put(
    `/HousingStock/address/${addressId}/comment_v2?commentId=${commentId}`,
    { comment },
    errorMessage,
    'Error'
  );
};

const useEditFlatComment = (options) => {
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data === 'Error') {
        return;
      }

      if (data.success === false) {
        message.error(data.message || errorMessage);
        return;
      }

      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
};

export default useEditFlatComment;
